// action types

export default {
  state: {
    editItem: null,
  },
  getters: {
    editItem(state) {
      return state.editItem;
    },
  },
  actions: {
    storeEditItem(context, item) {
      context.commit("saveEditItem", item);
    },
  },
  mutations: {
    saveEditItem(state, item) {
      state.editItem = item;
    },
    removeEditItem(state) {
      state.editItem = null;
    },
  },
};
